import JZoneList from './JZoneList'

/* istanbul ignore next */
JZoneList.install = function (Vue) {
  Vue.component(JZoneList.name, JZoneList)
}

export default JZoneList
